import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { setContext } from 'apollo-link-context';
import { createHttpLink } from 'apollo-link-http';
import fetch from 'isomorphic-unfetch';
import resolvers from '../clientGraphql/resolvers';

import dataIdFromObject from '../dataIdFromObject';
import fragmentMatcher from '../fragmentMatcher';
import { subscribeOnRequest } from './ApolloLinkNetworkStatus';
import buildRequestSubscriber from './requestSubscriber';

function createApolloClient({ apiUrl, initialState, storeProvider }) {
  const bearerLink = setContext((request, previousContext) => {
    const { bearerToken, ...restContext } = previousContext;

    if (!bearerToken) {
      return previousContext;
    }

    return {
      ...restContext,
      headers: {
        ...restContext.headers,
        Authorization: `Bearer ${bearerToken}`,
      },
    };
  });

  const googleIdTokenLink = setContext((request, previousContext) => {
    const { googleIdToken, ...restContext } = previousContext;

    if (!googleIdToken) {
      return previousContext;
    }

    return {
      ...restContext,
      headers: {
        ...restContext.headers,
        'X-Google-Id': googleIdToken,
      },
    };
  });

  const httpLink = createHttpLink({
    uri: `${apiUrl}/graphql`,
    credentials: 'include',
  });

  const requestSubscriber = subscribeOnRequest(
    buildRequestSubscriber(storeProvider),
  );

  const client = new ApolloClient({
    link: ApolloLink.from([
      requestSubscriber,
      bearerLink,
      googleIdTokenLink,
      httpLink,
    ]),
    cache: new InMemoryCache({ fragmentMatcher, dataIdFromObject }).restore(
      initialState,
    ),
    queryDeduplication: true,
    fetchOptions: { fetch },
    defaultOptions: {
      watchQuery: { fetchPolicy: 'network-only' },
      query: { fetchPolicy: 'network-only' }, //TODO current version of appolo client is broken, and defaultOptions for query applies only for watchQuery
    },
    resolvers,

    ssrMode: false,
  });
  storeProvider.apolloClient = client;

  return client;
}

export default createApolloClient;
